export const PAGINATION_LIMIT = 6;
